import React from "react";
import { FrameView } from "components/FrameView/FrameView";

export const WeatherForecast = () => {
  return (
    <FrameView
      title="Weather Forecast"
      src="https://m.rp5.kz/%D0%9F%D0%BE%D0%B3%D0%BE%D0%B4%D0%B0_%D0%B2_%D0%9A%D1%83%D0%BB%D1%8C%D1%81%D0%B0%D1%80%D1%8B"
    ></FrameView>
  );
};
